var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91758 4.52148C2.83111 4.52156 2.7466 4.54726 2.67472 4.59534C2.60285 4.64342 2.54683 4.71172 2.51375 4.79161C2.48067 4.87151 2.47201 4.95941 2.48885 5.04423C2.5057 5.12905 2.54731 5.20697 2.60842 5.26815L6.69175 9.35148C6.77378 9.43341 6.88498 9.47943 7.00092 9.47943C7.11686 9.47943 7.22805 9.43341 7.31008 9.35148L11.3934 5.26815C11.4545 5.20697 11.4961 5.12905 11.513 5.04423C11.5298 4.95941 11.5212 4.87151 11.4881 4.79161C11.455 4.71172 11.399 4.64342 11.3271 4.59534C11.2552 4.54726 11.1707 4.52156 11.0843 4.52148H2.91758Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.606a153e394ca5527578a0b3a30d3f72.svg";
export { ForwardRef as ReactComponent };